import styled from "styled-components";


export const Section = styled.section`

  width: 100%;
  margin: auto;
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;


h2 {
  margin-bottom: 60px;
  margin-top: 60px;
}

@media screen and (max-width: 450px) {
    h2{
      font-size: 25px;
    } 

}

`

export const Mastered = styled.div`
 width: 100%;
  border-bottom: 1px solid ${props => props.theme.siteColor};
  padding: 40px 0px;
display: grid;
grid-template-columns:  1fr 1fr 1fr 1fr 1fr;
gap: 50px;
justify-items: center;
  
@media screen and (max-width: 550px) {
  grid-template-columns:  1fr 1fr 1fr 1fr;  
  gap: 40px;

}


@media screen and (max-width: 450px) {
  grid-template-columns:  1fr 1fr 1fr;  
}

@media screen and (max-width: 350px) {
  gap: 30px;

}

`

export const Studying = styled.div`
 width: fit-content;
 display: grid;
 gap: 100px;
 grid-template-columns: 100px 100px 100px;
 justify-items: center;
 /* background-color: red; */


 @media screen and (max-width: 550px) {
  gap: 50px;

}

@media screen and (max-width: 450px) {
  gap: 10px;

}



`

export const Tech = styled.div`

div::before{
  content: "";
  display: inline-block;
  background-size: cover;
  width: 50px;
  height: 50px;
  margin-right: 10px;
  margin-bottom: -15px;
  background: url(${props => props.path}) center no-repeat;
}

`